<template>
  <div>
    <locationnetworks
      :locationnetworks="locationNetworks"
      :isloading="isLoading"
      @locationNetworkSaved="fetchLocationNetworks()"
    ></locationnetworks>
    <div>
    </div>
    
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import LocationNetworks from "@/components/LocationNetworkBasic.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    locationnetworks: LocationNetworks,
    loading: Loading
  },
  data() {
    return {
      locationNetworks: [],
      isLoading: true
    };
  },
  computed: {},
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/locationNetworkBasic'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },

  methods: {
    fetchLocationNetworks() {
      this.isLoading=true
      Api()
        .get("/locationNetworks/basic/active")
        .then(async response => {
          this.locationNetworks = response.data
          this.isLoading=false;
        });
    },
    initialize() {
      this.fetchLocationNetworks();
    }
  }
};
</script>
